'use client';

import {
  ThemeProvider as NextThemesProvider,
  type ThemeProviderProps,
} from 'next-themes';
import { usePathname } from 'next/navigation';
import * as React from 'react';

export function ThemeProvider({ children, ...props }: ThemeProviderProps) {
  const pathname = usePathname();
  const themeMap: Record<string, string | undefined> = {
    '/register': 'light',
    '/login': 'light',
    '/dashboard': 'light',
  };
  const forcedThemeFromPathname = themeMap[pathname];

  return (
    <NextThemesProvider
      enableSystem={true}
      forcedTheme={forcedThemeFromPathname}
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
